import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import HomeIcon from "@mui/icons-material/Home";
import AddBoxIcon from "@mui/icons-material/AddBox";
import SettingsIcon from "@mui/icons-material/Settings";
import { Link, useNavigate } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import { logoutRequest } from "../../services/auth/authSlice";
import { useDispatch, useSelector } from "react-redux";
import Container from "@mui/material/Container";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuList from "@mui/material/MenuList";
import { setUserProfile } from "../../services/profile/profileSlice";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import SidebarOption from "./SidebarOption";
import PublicIcon from "@mui/icons-material/Public";
import {
  setValueTab,
  setRoute,
  setLastStorePath
} from "../../services/globalSlice";
import SessionService from "../../services/session_service";
import { setLoading } from "../../services/auth/authSlice";
import {
  loadStyle,
  keyLang,
  checkStorePage,
  checkUserIsSeller,
  checkUserIsCustomer,
  allDomain
} from "../../utils/helpers";
import Translation from "../../utils/Translation";
import CheckNotification from "../../components/notification/CheckNotification";
import ProfileService from "../../services/profile/profile_service";
import StoreMallDirectoryIcon from "@mui/icons-material/StoreMallDirectory";
import AppBarCategory from "../customer/store/AppBarCategory";
import { setLanguage } from "../../services/globalSlice";
import { allLinks } from "../../utils/helpers";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { resetStore, setProducts } from "../../services/store/storeSlice";
import { setOrders } from "../../services/order/orderSlice";
import { AppBar, Badge, Button, ButtonGroup, Toolbar, Typography } from "@mui/material";
import TopBar from "./TopBar";
import UserAvatar from "../../components/navbar/UserAvatar";

function Navbar() {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const dynamicState = useSelector((state) => state.dynamicConfig);
  const { userProfile } = useSelector((state) => state.profile);
  const { t, i18n } = useTranslation();
  const { statusLogout, user } = useSelector((state) => state.auth);
  const { lastStorePath } = useSelector((state) => state.global);
  const navigate = useNavigate();
  let location = useLocation();


  const handleLanguage = (event, index) => {
    const lang = keyLang[index];
    i18n.changeLanguage(lang);

    loadStyle(lang);
    dispatch(setLanguage(lang));
  };

  const handleRoute = (newRoute) => {
    navigate(newRoute); // set new page by route
  };

  const HandleUserLogoutClick = async (setting) => {

    if (setting === "profile") {
      handleRoute(`/${allLinks[10]}`);
    }

    if (setting === "store") {
      handleRoute(`/${allLinks[13]}`);
    }

    if (setting === "address") {
      handleRoute(`/${allLinks[8]}`);
    }

    if (setting === "orders") {
      handleRoute(`/${allLinks[15]}`);
    }

    if (setting === "setting") {
      handleRoute(`/${allLinks[9]}`);
    }

    if (setting === "logout") {
      try {
        // Send logout session data first
        if (user && !user.isAnonymous) {
          await SessionService.sendLogoutSession(user);
        }
      } catch (error) {
        console.error("Error sending logout session data:", error);
      }

      let token = "0";
      ProfileService.updateFcmToken({ auth, dynamicState, token });
      localStorage.clear();

      dispatch(setLastStorePath(null));
      dispatch(setProducts([]));
      dispatch(setOrders([]));

      await dispatch(logoutRequest());
      dispatch(setLoading({ isLoading: true })); // run reloader
    }
  };

  useEffect(() => {
    handleRoute(location.pathname); // set route base on page
  }, []);

  // check if user find to redirect
  useEffect(() => {
    if (!user) {
      dispatch(setUserProfile({ userProfile: null }));
      dispatch(setLoading({ isLoading: false }));// run reloader
    }
  }, [statusLogout, dispatch]);

  // save last page on store
  useEffect(() => {
    allLinks.forEach((link, index) => {
      if (location.pathname.includes(link)) {
        dispatch(setRoute(link));
        if (index === 2) dispatch(setValueTab(0));

        if (index === 3 || index === 14) dispatch(setValueTab(1));

        if (index === 4 || index === 16 || index === 17 || index === 8)
          dispatch(setValueTab(2));

        if (index === 9 || index === 10 || index === 13) {
          (checkUserIsCustomer(userProfile) || userProfile === null) && dispatch(setValueTab(2));
          checkUserIsSeller(userProfile) && dispatch(setValueTab(3));
        }
      }

      // You can perform any side effect here
    });

  }, [location.pathname]);

  return (
    <>
      {/* Top Bar */}
      {(checkUserIsCustomer(userProfile) || userProfile === null) && (
        <TopBar handleLanguage={handleLanguage} />
      )}

      {(checkStorePage() && (checkUserIsCustomer(userProfile) || userProfile === null)) && (
        <StoreSection
          handleLanguage={handleLanguage}
          handleRoute={handleRoute}
          HandleUserLogoutClick={HandleUserLogoutClick}
        />
      )}

      {(!checkStorePage() || checkUserIsSeller(userProfile)) && (
        <DeliveryAndSellerSection
          handleLanguage={handleLanguage}
          handleRoute={handleRoute}
          HandleUserLogoutClick={HandleUserLogoutClick}
          auth={auth}
        />
      )}
    </>
  );
}

const StoreSection = memo(({ HandleUserLogoutClick, handleRoute, handleLanguage }) => {
  const { totalQuantity } = useSelector((state) => state.cart);
  const { userProfile } = useSelector((state) => state.profile);
  const langs = ["English", "Arabic"];
  const navigate = useNavigate();
  const BackToHomePage = async () => window.location.href = allDomain.ecommerce;

  return (
    <>
      {/* Main Header */}
      <AppBar
        position="static"
        color="default"
        sx={{
          boxShadow: 1,
          backgroundColor: 'background.paper',
          paddingRight: "5%",
          paddingLeft: "5%",
        }}
        className="appbar"
      >
        <Toolbar
          sx={{
            justifyContent: "space-between",
            paddingTop: ".3%",
            paddingBottom: ".3%",
          }}
        >
          {/* Logo */}
          <Box display="flex" alignItems="center">
            <Link onClick={() => BackToHomePage()}>
              <img
                src={require("../../assets/image/layout/logo-header.png")}
                alt="logo"
                height="67.69px"
                className="logo-header"
              />
            </Link>
          </Box>

          <Box display="flex" width={"80%"} alignItems="center">
            <AppBarCategory />
          </Box>

          {/* Right Side Icons */}
          <Box
            className="navbar-icon-shop desktop-option"
            display="flex"
            alignItems="center"
            gap={2}
          >
            {userProfile && <Box>
              <CheckNotification />
            </Box>
            }

            <IconButton onClick={() => navigate(`/${allLinks[6]}`)}>
              <Badge badgeContent={totalQuantity} color="error">
                <ShoppingCartIcon />
              </Badge>
            </IconButton>

            {userProfile ? (
              <UserAvatar HandleUserLogoutClick={HandleUserLogoutClick} />
            ) : (

              <>
                <Button
                  className="login-button"
                  onClick={() => navigate(`/${allLinks[0]}`)}
                >
                  <Translation data="auth.navbar" />
                </Button>
              </>

            )}
          </Box>

          <Box
            className="mobile-option margin-auto mobile-button primary-color"
            display="flex"
            alignItems="center"
          >

            {userProfile ? (
              <SidebarOption
                handleRoute={handleRoute}
                handleLanguage={handleLanguage}
                HandleUserLogoutClick={HandleUserLogoutClick}
                langs={langs}
                isSeller={checkUserIsSeller(userProfile)}
              />
            ) :
              <Button
                className="login-button"
                onClick={() => navigate(`/${allLinks[0]}`)}
              >
                <Translation data="auth.navbar" />
              </Button>
            }

          </Box>
        </Toolbar>
      </AppBar>

    </>
  );
});

const DeliveryAndSellerSection = memo(({
  handleLanguage,
  handleRoute,
  HandleUserLogoutClick,
  auth
}) => {
  const langs = ["English", "Arabic"];
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const { userProfile } = useSelector((state) => state.profile);
  const { language, valueTab } = useSelector((state) => state.global);
  const navigate = useNavigate();

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  return (
    <Box sx={{ flexGrow: 5 }} className="navbar-background">
      <Container className="no-padding page_size navbar-MuiTabScrollButton-horizontal">
        <Grid container spacing={3}>
          <Grid
            container
            size={{ lg: 2, md: 2, sm: 2 }}
            className="responsive-logo"
          >
            <Grid className="margin-auto padding-main-logo">
              <Link onClick={() => handleRoute("/")} to="/">
                <img
                  src={require("../../assets/image/layout/logo.png")}
                  className="main-logo"
                  alt=""
                />
              </Link>
            </Grid>
          </Grid>

          <Grid size={{ lg: 8, md: 7, sm: 8, xs: 8 }}>
            <Tabs
              value={valueTab}
              className="space-around-tabs"
              variant="scrollable"
              scrollButtons="auto"
              aria-label="scrollable auto tabs example"
            >
              <Tab
                icon={<HomeIcon />}
                label=<Translation data="layout.home" />
                className="color-navbar"
                onClick={() => handleRoute("/")}
              />

              {/* route for customer */}
              {!checkUserIsSeller(userProfile) && (
                <Tab
                  icon={<AddBoxIcon />}
                  label=<Translation data="layout.add_request" />
                  className="color-navbar"
                  onClick={() => handleRoute(`/${allLinks[3]}`)}
                />
              )}

              {/* route for seller */}
              {checkUserIsSeller(userProfile) && (
                <Tab
                  icon={<ShoppingCartIcon />}
                  label=<Translation data="layout.orders" />
                  className="color-navbar"
                  onClick={() => handleRoute(`/${allLinks[14]}`)}
                />
              )}
              {checkUserIsSeller(userProfile) && (
                <Tab
                  icon={<StoreMallDirectoryIcon />}
                  label=<Translation data="layout.inventory" />
                  className="color-navbar font-size-30"
                  onClick={() => handleRoute(`/${allLinks[4]}`)}
                />
              )}

              <Tab
                icon={<SettingsIcon />}
                label=<Translation data="layout.setting" />
                className="color-navbar"
                onClick={() => handleRoute(`/${allLinks[9]}`)}
              />
            </Tabs>
          </Grid>

          <Grid
            size={{ lg: 2, md: 3, sm: 2 }}
            className="desktop-option"
            container
          >

            {checkUserIsSeller(userProfile) ?
              <Grid className="margin-auto" size={{ lg: 3, md: 3, sm: 3, xs: 3 }}>
                <ButtonGroup
                  variant="contained"
                  ref={anchorRef}
                  className="box-shadow-unset"
                  aria-label="Button group with a nested menu"
                >
                  <IconButton
                    size="small"
                    aria-controls={open ? "split-button-menu" : undefined}
                    aria-expanded={open ? "true" : undefined}
                    aria-label="select merge strategy"
                    aria-haspopup="menu"
                    onClick={handleToggle}
                  >
                    <PublicIcon />
                  </IconButton>
                </ButtonGroup>
                <Popper
                  sx={{
                    zIndex: 1,
                  }}
                  open={open}
                  anchorEl={anchorRef.current}
                  role={undefined}
                  transition
                  disablePortal
                >
                  {({ TransitionProps, placement }) => (
                    <Grow
                      {...TransitionProps}
                      style={{
                        transformOrigin:
                          placement === "bottom" ? "center top" : "center bottom",
                      }}
                    >
                      <Paper>
                        <ClickAwayListener onClickAway={handleClose}>
                          <MenuList id="split-button-menu" autoFocusItem>
                            {langs.map((option, index) => (
                              <MenuItem
                                key={option}
                                disabled={index === 2}
                                selected={
                                  index === (language === keyLang[0] ? 0 : 1)
                                }
                                onClick={(event) => handleLanguage(event, index)}
                              >
                                {option}
                              </MenuItem>
                            ))}
                          </MenuList>
                        </ClickAwayListener>
                      </Paper>
                    </Grow>
                  )}
                </Popper>
              </Grid> :
              <Grid
                className="margin-auto"
                size={{ lg: 3, md: 3, sm: 3, xs: 3 }}
              ></Grid>
            }

            <Grid className="margin-auto" size={{ lg: 3, md: 3, sm: 3, xs: 3 }}>
              {userProfile && <CheckNotification />}
              <Popper
                sx={{
                  zIndex: 1,
                }}
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
              >
                {({ TransitionProps, placement }) => (
                  <Grow
                    {...TransitionProps}
                    style={{
                      transformOrigin:
                        placement === "bottom" ? "center top" : "center bottom",
                    }}
                  >
                    <Paper>
                      <ClickAwayListener onClickAway={handleClose}>
                        <MenuList id="split-button-menu" autoFocusItem>
                          {langs.map((option, index) => (
                            <MenuItem
                              key={option}
                              disabled={index === 2}
                              selected={
                                index === (language === keyLang[0] ? 0 : 1)
                              }
                              onClick={(event) => handleLanguage(event, index)}
                            >
                              {option}
                            </MenuItem>
                          ))}
                        </MenuList>
                      </ClickAwayListener>
                    </Paper>
                  </Grow>
                )}
              </Popper>
            </Grid>

            <Grid
              className="margin-auto padding-profile"
              size={{ lg: 6, md: 6, sm: 6, xs: 6 }}
            >

              {userProfile ? (
                <UserAvatar HandleUserLogoutClick={HandleUserLogoutClick} />
              ) : (
                <>
                  <Button
                    className="login-button"
                    onClick={() => navigate(`/${allLinks[0]}`)}
                  >
                    <Translation data="auth.navbar" />
                  </Button>
                </>
              )}

            </Grid>
          </Grid>

          <Grid
            className="mobile-option margin-auto mobile-button"
            size={{ sm: 1, xs: 4 }}
          >
            {userProfile ?
              <SidebarOption
                handleRoute={handleRoute}
                handleLanguage={handleLanguage}
                HandleUserLogoutClick={HandleUserLogoutClick}
                langs={langs}
                isSeller={checkUserIsSeller(userProfile)}
              />
              :
              <Button
                className="login-button"
                onClick={() => navigate(`/${allLinks[0]}`)}
              >
                <Translation data="auth.navbar" />
              </Button>
            }
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
});

export default memo(Navbar);
